// extracted by mini-css-extract-plugin
module.exports = {"blogItem":"blog-preview-module--blog-item--3yJ4U","blogDetail":"blog-preview-module--blog-detail--2AuEJ"};